import React, { useRef } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSort, faSortUp, faSortDown } from '@fortawesome/pro-light-svg-icons';
import { isIE, isEdge } from '../../../../common/utilities/browserDetection';
import { withTranslation } from 'react-i18next';
import { CONFIGURATION_SET_COLUMNS, MIN_COLUMN_WIDTH_PERCENT } from './configurationSetColumns';

const HeaderContainer = styled.div`
    color: #333;
    font-weight: 500;
    height: 25px;
    text-align: left;
    position: relative;
    display: flex;
    background-color: #fff;
    border-top: 1px solid #E6EDF5;
    border-bottom: 1px solid #E6EDF5;
    height: fit-content;
    padding: ${props => (isIE() || isEdge()) ? `15px 0 40px 10px;` : `15px 0 15px 10px;`}
`
const ResizeHandle = styled.div`
    position: absolute;
    top: -15px;
    bottom: -15px;
    right: -4px;
    width: 9px;
    cursor: col-resize;
    user-select: none;
    z-index: 2;
    display: flex;
    justify-content: center;

    &::after {
        content: '';
        width: 2px;
        background-color: transparent;
    }
`
const Column = styled.div`
    position: relative;
    box-sizing: border-box;

    &:hover ${ResizeHandle}::after {
        background-color: #1976d2;
    }
`
const SortLabel = styled.div`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 5px;
    width: fit-content;

    &:hover .cstr-sort-icon-inactive {
        opacity: 1;
    }
`
const ActiveSortIcon = styled(FontAwesomeIcon)`
    color: #1976d2;
    font-size: 0.85em;
`
const InactiveSortIcon = styled(FontAwesomeIcon)`
    color: #98a2b3;
    font-size: 0.85em;
    opacity: 0;
    transition: opacity 150ms ease;
`

const SettingHeader = (props) => {
    const { t, columnWidths, onColumnWidthsChange } = props;
    const containerRef = useRef(null);

    const startResize = (event, leftKey, rightKey) => {
        event.preventDefault();
        event.stopPropagation();
        const containerWidth = containerRef.current ? containerRef.current.clientWidth : 1;
        const startX = event.clientX;
        const leftStart = columnWidths[leftKey];
        const rightStart = columnWidths[rightKey];

        const onMove = (moveEvent) => {
            const deltaPx = moveEvent.clientX - startX;
            let deltaPct = (deltaPx / containerWidth) * 100;
            const minDelta = -(leftStart - MIN_COLUMN_WIDTH_PERCENT);
            const maxDelta = rightStart - MIN_COLUMN_WIDTH_PERCENT;
            deltaPct = Math.max(minDelta, Math.min(maxDelta, deltaPct));
            onColumnWidthsChange((prev) => ({
                ...prev,
                [leftKey]: leftStart + deltaPct,
                [rightKey]: rightStart - deltaPct,
            }));
        };
        const onUp = () => {
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
    };

    return (
        <HeaderContainer ref={containerRef}>
            {CONFIGURATION_SET_COLUMNS.map((col, index) => {
                const isLast = index === CONFIGURATION_SET_COLUMNS.length - 1;
                const isSorted = props.sortBySelected === col.sortKey;
                return (
                    <Column key={col.key} width={100} style={{ width: `${columnWidths[col.key]}%` }}>
                        <SortLabel onClick={() => { props.sortBy(col.sortKey) }}>
                            {t(col.tKey)}
                            {isSorted
                                ? <ActiveSortIcon icon={props.sortOrder === 'Ascending' ? faSortUp : faSortDown} />
                                : <InactiveSortIcon className="cstr-sort-icon-inactive" icon={faSort} />}
                        </SortLabel>
                        {!isLast && (
                            <ResizeHandle
                                onMouseDown={(event) => startResize(event, col.key, CONFIGURATION_SET_COLUMNS[index + 1].key)}
                                onClick={(event) => event.stopPropagation()}
                            />
                        )}
                    </Column>
                );
            })}
        </HeaderContainer>
    );
};
export default withTranslation('employmentBillboard')(SettingHeader);